export const name: string = 'Gantt'; // 'React Gantt';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-gantt';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-gantt';
//export const priority: number = 1;